/* @flow */
import File from 'entities/File';
import MediaPlayer from 'components/MediaPlayer.jsx';
import React from 'react';

import { isSupportedType } from 'lib/AudioSupport';
import { uniqueId } from 'lodash';

/**
 * Inline HTML5 audio player.
 *
 * Use `Audio.isSupportedType(type)` to check whether the audio file  can be played inline on the
 * user's browser.
 *
 * ```example
 * <Audio src="https://www.remind.com/assets/audio/pn.mp3" />
 * ```
 */
class Audio extends React.Component {
  static propTypes = {
    /** URL to the audio file */
    src: React.PropTypes.string.isRequired,
    /** File entity for the associated audio file */
    file: React.PropTypes.instanceOf(File),
  };

  static isSupportedType = isSupportedType;

  state = {
    id: uniqueId(),
  };

  render() {
    return (
      <div className="Audio">
        <audio id={this.state.id} src={this.props.src}>
          Your browser does not support the <code>audio</code> element.
        </audio>
        <MediaPlayer
          playerId={this.state.id}
          theme="light"
          src={this.props.src}
          file={this.props.file}
        />
      </div>
    );
  }
}

export default Audio;



// WEBPACK FOOTER //
// ./src/components/Audio.jsx